module.exports = __webpack_public_path__ + "static/media/day19_keyboard.5a5dea6c.gif";